import { createTheme } from "@mui/material/styles";

// Aplica para objetos de Material UI dentro de un ThemeProvider
export const mainTheme = createTheme({
  palette: {
    primary: {
      // Dark blue.
      main: "#0E273C",
    },
    secondary: {
      // Light Green
      main: "#00E676",
    },
    success: {
      // Dark green color hex
      main: "#003300",
    },
    danger: {
      // Red color hex
      main: "#FF0000",
    },
  },
});
